import axios from "axios";
import { getToken, clearToken } from "./tokenStorage";

// Production API on Render; override with REACT_APP_API_URL for local dev
const API_URL =
  process.env.REACT_APP_API_URL || "https://staycation-server-v1-1.onrender.com";

const axiosInstance = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true, // Send cookies when browser allows (same-site / Render cookie)
  headers: {
    "Content-Type": "application/json",
  },
});

// Bearer fallback — required for Vercel frontend → Render API (cross-origin)
axiosInstance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const isLoginRequest = error?.config?.url?.includes("/auth/login");

    if ((status === 401 || status === 403) && !isLoginRequest) {
      clearToken();
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
